import * as titleCase from "lodash/capitalize";

export function capitalize(value) {
    return titleCase(value);
}
